// extracted by mini-css-extract-plugin
export default {"container":"PaymentSelection_container__zmlMs"};